import axios from 'axios';

export const apiGet = async <T>(url: string) => {
  const response = await axios.get(url);
  return { data: response?.data as T };
};
